import { Pipe, PipeTransform } from '@angular/core';

// @Pipe({ name: 'filesize', standalone: true })
// export class FileSizePipe implements PipeTransform {
//   transform(size: number, extension: string = 'MB') {
//     return (size / (1024 * 1024)).toFixed(2) + extension;
//   }
// }


@Pipe({
  name: 'filesize',
  standalone: true,
})
export class FileSizePipe implements PipeTransform {
  transform(bytes: number, decimals = 0): string {
    const fileSize = toFileSize(bytes, decimals)
    return `${fileSize.amount.toFixed(decimals)} ${fileSize.unit}`
  }
}

const toFileSize = (bytes: number, decimals = 2) => {
  if (bytes === 0) return { amount: 0, unit: 'bytes' };

  const units = ['bytes', 'KB', 'MB', 'GB', 'TB'];
  const index = Math.floor(Math.log(bytes) / Math.log(1024));
  const amount = Number((bytes / 1024 ** index).toFixed(decimals));

  return {
    amount,
    unit: amount === 1 && index === 0 ? 'byte' : units[index]
  };
};